import module from 'usuario/module.js'

const schema = {
  activo: 'boolean',
}

class UsuarioPermisosClientesService {
  constructor ($http) {
    this.$http = $http
  }

  get (idUsuario) {
    return this.$http.get('/api/usuarios/usuario/permisos/clientes', {
      params: {id_usuario: idUsuario},
      schema,
    })
  }

  put (idUsuario, data) {
    return this.$http.put('/api/usuarios/usuario/permisos/clientes', data, {
      params: {id_usuario: idUsuario},
      schema,
    })
  }
}

module.service('UsuarioPermisosClientes', UsuarioPermisosClientesService)



// WEBPACK FOOTER //
// ./src/usuario/services/Usuario/Permisos/Clientes.js